import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Moon, Sun } from 'lucide-react';
import useThemeStore from '../store/themeStore';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useThemeStore();
  const { t } = useTranslation();

  return (
    <Button
      data-testid="theme-toggle-button"
      onClick={toggleTheme}
      variant="outline"
      size="sm"
      className="gap-2"
    >
      {theme === 'light' ? (
        <Moon className="h-4 w-4" />
      ) : (
        <Sun className="h-4 w-4" />
      )}
      {theme === 'light' ? t('dark') : t('light')}
    </Button>
  );
};

export default ThemeToggle;